'use client'

import SvgIcon from '@mui/material/SvgIcon'
import PropTypes from 'prop-types'

export const SingleEmailIcon = ({ sx }) => {
  return (
    <SvgIcon sx={sx} data-testid="SingleEmailIcon">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        id="Envelope--Streamline-Ultimate"
        height="24"
        width="24"
      >
        <desc>Envelope Streamline Icon: https://streamlinehq.com</desc>
        <defs></defs>
        <title>envelope</title>
        <path
          d="M2 4.5h20s1.5 0 1.5 1.5v12s0 1.5 -1.5 1.5H2S0.5 19.5 0.5 18V6S0.5 4.5 2 4.5"
          fill="none"
          stroke="#333333"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
        ></path>
        <path
          d="M20.5 8.5 12 14 3.5 8.5"
          fill="none"
          stroke="#333333"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
        ></path>
        <path
          d="M3.5 16 7 14"
          fill="none"
          stroke="#333333"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
        ></path>
        <path
          d="M20.5 16 17 14"
          fill="none"
          stroke="#333333"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
        ></path>
      </svg>
    </SvgIcon>
  )
}

SingleEmailIcon.propTypes = {
  sx: PropTypes.object
}
